module.exports = __webpack_public_path__ + "static/media/Stories.00aadeb7.svg";